var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 8.377h-4.2V6.4c0-.31-.235-.56-.525-.56H7.181v-.7c0-.077-.059-.14-.131-.14h-.919C6.06 5 6 5.063 6 5.14v13.72c0 .077.06.14.131.14h.919c.072 0 .131-.063.131-.14v-4.62h4.069v1.978c0 .31.235.56.525.56H18.6c.29 0 .525-.25.525-.56v-7.28c0-.31-.235-.56-.525-.56zM7.181 12.98V7.1h6.038v5.88H7.18zm10.763 2.537H12.43V14.24h1.838c.072 0 .131-.063.131-.14V9.637h3.544v5.88z",
    fill: "currentColor"
  })));
}
export default SvgLanguage;